import React, { useState, useContext, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { getConfigValue } from '../../util/getConfigValue';
import { AppContext } from '../../util/AppContext';
import PropTypes from 'prop-types';

QuickSheetsAlertModal.propTypes = {
    show: PropTypes.bool,
    setShow: PropTypes.func,
    onAcceptFileNameChange: PropTypes.func
};
function QuickSheetsAlertModal({ show, setShow, onAcceptFileNameChange }) {    
    const [appState] = useContext(AppContext);
    const [title, setTitle] = useState(null);
    const [body, setBody] = useState(null);
    const [buttonText, setButtonText] = useState(null);
    const [buttonColor, setButtonColor] = useState(null);

    useEffect(() => {
        if (!show) {
            return;
        }

        setTitle(getConfigValue(appState?.config?.QuickSheets?.Admin?.Modal?.ReplaceFilename?.Title, appState)?.Value || null);
        setBody(getConfigValue(appState?.config?.QuickSheets?.Admin?.Modal?.ReplaceFilename?.Body, appState)?.Value || null);
        setButtonText(getConfigValue(appState?.config?.QuickSheets?.Admin?.Modal?.ReplaceFilename?.Ok?.Button, appState)?.Value || null);     
        setButtonColor('primary');
    }, [show]);

    const handleClose = () => setShow(false);

    function handleClick() {
        onAcceptFileNameChange();
        setShow(false);
    }

    return (
        <Modal className='modal-lg' show={show} onHide={handleClose}>
            <Modal.Header className={`modal-header`} closeButton>
                <Modal.Title className='modal-title fs-5'>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='modal-body'>
                <p>{body}</p>
            </Modal.Body>
            <Modal.Footer className='modal-footer'>
                <div className='col-12 col-md-10 col-lg-7 px-0'>
                    <div className='d-flex w-100 flex-column flex-md-row-reverse'>
                        <Button
                            className={`btn btn-${buttonColor} btn-lg mb-3 mb-md-0 ms-md-3 flex-fill w-100`}
                            size='lg'
                            onClick={handleClick}>
                            {buttonText}
                        </Button>
                        <Button className='btn btn-secondary btn-lg flex-fill w-100' size='lg' onClick={handleClose}>
                            {getConfigValue(appState?.config?.Common?.Cancel, appState)?.Value}
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default QuickSheetsAlertModal;
